import DoctorImage from '../Assets/DoctorImg/doctor4.png';
import DoctorImage2 from '../Assets/DoctorImg/doctor2.jpg';
export const FakeDoctors = [
    // {
    //     "id": "001",
    //     "name": "Mike Jackson",
    //     "status": "Physiotherapist",
    //     "img": "https://i.ibb.co/pz92gsK/d1.png"
    // },
    {
        "id": "002",
        "name": "Dr. Abhinav Anand",
        "status": "Physiotherapist",
        "img": DoctorImage
        // "img": "https://i.ibb.co/yRcJ55b/d2.png"
    },
    {
        "id": "003",
        "name": "Dr. Vedanshi Singh",
        "status": "Physiotherapist",
        "img": DoctorImage2
        // "img": "https://i.ibb.co/zJXZcqW/d3.png"
        // "img": "https://i.ibb.co/yRcJ55b/d2.png"
    }
]